export function config ($logProvider) {
  'ngInject';
  // Enable log
  $logProvider.debugEnabled(true);
}
